export const tinymceInitConfig = {
  base_url: '/tinymce',
  suffix: '.min',
  plugins: 'advlist autolink link anchor media paste code',
  toolbar: 'bold italic | link',
  menubar: 'false',
  statusbar: false,
  forced_root_block: '',
  entity_encoding: 'raw',
  toolbar_items_size: 'small',
  setup: null,
  participant_details: null,
  calculated_variables: null,
  modules: null,
  study_type: '',
  graph_field: false,
};

export const templatesTinymceInitConfig = {
  base_url: '/tinymce',
  suffix: '.min',
  plugins: 'advlist autolink link anchor media paste code',
  toolbar: 'fontselect bold italic | alignleft aligncenter alignright alignjustify',
  menubar: 'false',
  statusbar: false,
  forced_root_block: '',
  entity_encoding: 'raw',
  toolbar_items_size: 'small',
  setup: null,
  participant_details: null,
  calculated_variables: null,
  modules: null,
  study_type: '',
  graph_field: false,
  height: 150,
};
